<template>
<v-container grid-list-md fluid>
  <v-layout row wrap>
    <v-flex md12>
      <v-layout row >
          <v-flex lg4 md5  sm12 xs12 >
            <v-card class="text-xs-center">
              <!-- <v-card-text> -->
                <v-layout align-center justify-center row  >
                  <v-btn class="text-md-center"                  
                    absolute
                    fab
                    top
                    right
                    @click="submit()"
                    :disabled="state.isDisableButtonSubmit()" 
                    color="primary">
                    <v-icon>check</v-icon>
                  </v-btn>
                  <a id="datos_perfil" href="#" > 
                    <div 
                      @mouseover="croppaRemoveBtnShow()"
                      @mouseleave="croppaRemoveBtnHide()">
                      <croppa v-model="croppa"
                        class="userdp"
                        :initial-image="fotoPerfil"
                        :width="150"
                        :height="150"
                        placeholder="Selecciona una imagen"
                        placeholder-color="#000"
                        :placeholder-font-size="10"
                        canvas-color="transparent"
                        :show-loading="true"
                        :loading-size="25"
                        loading-color="#606060"
                        initial-position="center"
                        initial-size="cover"
                        :show-remove-button="false"
                        :prevent-white-space="true"   
                        :loading-end="croppaLoadingEnd()"               
                      ></croppa><br/>
                      <button type="button" 
                        title="Remover imagen"
                        class="btn btn-outline btn-circle btn-primary" 
                        v-show="view.elem.button.removeImg.visible" @click="croppaRemove()"
                        >                         
                        <i class="button__icon icon fa fa-times"></i>
                      </button>
                    </div>  
                    <!-- <upload-image ref="uploadImage"></upload-image>               -->
                    <h3 id="h3username" class="m-b-xs" style="font-size: 23px;">
                      <strong id="username" data-id="username">{{perfilUsuarioLoadedData.nombre}}</strong>
                    </h3>
                    <div class="font-bold" style="font-size: 16px;">{{perfilUsuarioLoadedData.username}}</div>
                    <address class="m-t-md" style="font-size: 15px;">
                      <i class="fa fa-envelope"></i> <strong>{{perfilUsuarioLoadedData.correoElectronico}}</strong><br> <br>
                      <div class="row">
                        <div class="col-md-12">
                          <span style="font-weight: bold;">Perfiles</span>  
                          <div style="font-size: 15px;"> 
                            {{getGroups}}
                              <br>
                              <br>
                          </div> 
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-6">
                                <span style="font-weight: bold;">Teléfono</span>  
                                <div style="font-size: 15px;"> 
                                  {{perfilUsuarioLoadedData.telefono}}
                                </div>
                              </div>
                              <div class="col-md-6">
                                <span style="font-weight: bold;">Interno</span>  
                                <div style="font-size: 15px;"> 
                                {{perfilUsuarioLoadedData.interno}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group" style="display:none;">
                            <input type="text" name="foto" class="form-control"
                              v-model="$v.perfilUsuario.foto.$model">
                        </div>                     
                        <div class="form-group" style="display:none;">
                            <input type="text" name="username" class="form-control" 
                              v-model="$v.perfilUsuario.username.$model">
                        </div> 
                      </div>
                    </address>
                  </a>
                </v-layout>
              <!-- </v-card-text> -->
            </v-card>
          </v-flex>
        
        <v-flex id="vertical-timeline" 
          class="vertical-container light-timeline 
                center-orientation col-lg-6 col-md-6 col-sm-12 col-xs-12 
                vertical-timeline-top-off" 
          style="margin-left: 3%; width:50%; margin-right: 3%; margin-top:0px;">
          <div class="vertical-timeline-block" style="display: none;">
              <div class="vertical-timeline-icon timeline-circle-orange">
                  <i class="fa fa-unlock"></i>
              </div>
              <div class="vertical-timeline-content">
                  <h4>Último cambio</h4>
                  <p>{{getUltimoCambio}}</p>          
              </div>
          </div>
          <div class="vertical-timeline-block" >
              <div class="vertical-timeline-icon timeline-circle-orange">
                  <i class="fa fa-unlock"></i>
              </div>

              <div class="vertical-timeline-content">
                  <h4>Último cambio</h4>
                  <p>{{getUltimoCambio}}</p>                                                        
              </div>
          </div>
          <div class="vertical-timeline-block" >
              <div class="vertical-timeline-icon timeline-circle-orange">
                  <i class="fa fa-clock-o"></i>
              </div>
              <div class="vertical-timeline-content">
                  <h4  style="margin-top: 0px !important;margin-bottom: 0px !important;">Tiempo Restante</h4>
                  <p>{{getUserData.diasVencimiento}} Días</p> 
              </div>
          </div>
          <div class="vertical-timeline-block" >
              <div class="vertical-timeline-icon timeline-circle-orange">
                  <i class="fa fa-lock"></i>
              </div>
              <div class="vertical-timeline-content">
                  <h4 style="margin-top: 0px !important;margin-bottom: 0px !important;">Próximo cambio de contraseña</h4>
                  <p>{{getProximoCambio}}</p>                    
              </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex> 
  </v-layout>
</v-container>

</template>
<script>
import {PerfilUsuarioModel} from "@/models/seguridad/perfil-usuario";
import PerfilUsuarioAPI from "@/services/seguridad/perfilUsuario";
import CombosAPI from "@/services/catalogos";
import {required} from "vuelidate/lib/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import Multiselect from 'vue-multiselect';
import tippy from 'tippy.js';
import * as states from '@/views/seguridad/perfilUsuario/perfil-usuario-states';
import * as R from "ramda";
import {isNotEmpty, isEmpty} from "@/helpers/validators";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import {getErrors,getBusinessCode,getResponseDTO} from '@/helpers/http-response-handler';
import * as actions from "@/constants/mutation-names";
import 'vue-croppa/dist/vue-croppa.css';

let croppa = {};
let croppaInitialImage = undefined;

//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
    , class:{
      current:""
      , save:"button__icon icon fa fa-plus" 
      , update:"button__icon icon fa fa-check"
    }
    , data:{
       id: 0
    }
  }
  , clear:{
    visible:false
  }
  , audit:{
    visible:false
  }
  , removeImg:{
    visible:false
  }
  
};


//Action's state
const action = {
  submit:{
    busy:false
  }
};



export default {
  name: "PerfilUsuario",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  ,data() {
    return {
      locale: this.$store.language
      , perfilUsuario : undefined
      , perfilUsuarioLoadedData: []
      , state : new Object()
      , view:{
        title:"Perfil del Usuario"
        , action
        , elem:{
          button
          , croppa
        }
      }
    };  
  },
  methods: {
    ...allValidatorMethods
    , async submit(){
      try{
        if(this.croppa.hasImage()){
          
          let fotoPerfil = this.perfilUsuario.foto;
        
          const respuesta = await this.state.submit(this.perfilUsuario);
          console.log(respuesta)
          if(respuesta.data.meta.code == 'OK')
          { 
            this.$store.dispatch(actions.USER_SET_FOTO_PERFIL,{fotoPerfil});
            this.croppaInitialImage = this.croppa.value.generateDataUrl();
            this.perfilUsuario.foto = respuesta.data.results.usuario.foto;
            EventBus.$emit(events.MESSAGES, {type:respuesta.data.meta.code});
          }
          else{
            if(response != false)
              EventBus.$emit(events.MESSAGES, {type:'error',message: getErrors('PerfilUsuario','Mensaje Default',respuesta.data.meta.code)});
          }
        }
        else {
          EventBus.$emit(events.MESSAGES,{type:'error',message:'VL0001 Por favor, seleccione una imagen'});
        }

        
      }catch(error){
      }
    }
    , toggleShow() {
      this.$refs.uploadImage.toggleShow();
    }
    , addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
    , getLimitText(){
      return count=> ` y  ${count} más `;
    }
    ,
    formatDate( date, params ) {
      var options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
      };
      if( params ) {
          options = Object.assign( options, params );
      }
      return new Date( date ).toLocaleString( 'es-MX', options );
    }
    , setPerfilUsuario(usuario){
      Object.setPrototypeOf(this.state, new states.EditingState(this,usuario));
    }
    , croppaRemove(){
      try{
        this.view.elem.button.removeImg.visible = false;
        this.croppa.remove();
      } catch(error){}
    }
    , croppaRemoveBtnShow(){
      try{
        if(this.croppa.hasImage())
          this.view.elem.button.removeImg.visible = true;
      } catch(error){}
    }
    , croppaRemoveBtnHide(){
        this.view.elem.button.removeImg.visible = false;
    }
    , croppaLoadingEnd(){
      try{
        if(this.croppaInitialImage == undefined)
        {
          this.croppaInitialImage = this.croppa.value.generateDataUrl();
        }

        if(this.croppaInitialImage != this.croppa.value.generateDataUrl()){
          this.perfilUsuario.foto = this.croppa.value.generateDataUrl();
          this.croppaInitialImage = this.croppa.value.generateDataUrl();
        }
        
      } catch(error){}
    }
  }
  , computed:{
    getUserData(){
      if(!this.$store.getters.getUserData) return [];
      return this.$store.getters.getUserData;
    }
    , getObrasSociales(){
      if(!this.$store.getters.getUserData.obrasSociales) return [];
      return this.$store.getters.getUserData.obrasSociales;
    }
    , submitClass(){
      return this.view.elem.button.submit.class.current;
    }
    , getUltimoCambio(){
      if(this.$store.getters.getUserData)
        return this.formatDate(this.getUserData.ultimaModificacionPassword);
    }
    , getProximoCambio(){
      if(this.$store.getters.getUserData)
       return this.formatDate(this.$store.getters.getUserData.fechaVencimiento);        
    }
    , getGroups(){
       if(!this.$store.getters.getUserData.grupos) return '';
      return this.$store.getters.getUserData.grupos.join(', ');
    }
    , fotoPerfil() {
      if(isNotEmpty(this.$store.getters.getUserData.fotoPerfil))
        return this.$store.getters.getUserData.fotoPerfil
      
      return '/static/img/user_thumbnail.jpg';
    }
  }
  , components: {
    VueContentLoading
  }
  , validations:{
    perfilUsuario:{
      foto:{
        required
      }
      , username:{
        required
      }
    }
  }
  , async created(){
    Object.setPrototypeOf(this.state, new states.InitialState(this));
    try{
        let username = this.getUserData.username;
        const response = await PerfilUsuarioAPI.get({username});
        const responseCombosObrasSocialesAll = await CombosAPI.get({tipo:'obrasSociales'});
        
        const {data:{results:{usuario}}} = response;
        const {data:{results:{combo}}} = responseCombosObrasSocialesAll;
        // this.$refs.uploadImage.imgDataUrl = usuario.foto;
        
        this.perfilUsuarioLoadedData = usuario;
        this.setPerfilUsuario(usuario);
      
        

        Object.setPrototypeOf(this.state, new states.EditingState(this,this.perfilUsuario));
        
      }catch(error){
        console.log(error)
      }
  }
  , mounted(){
    // this.$parent.appJQueryConfigMethod();
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
  color: #000;
}
.userdp {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden; 
  margin: 0 auto;
  background: none;
}
.contact-box.center-version > a img {
    width: 100% !important;
    height: 100% !important;
    margin-top: 10px;
    margin-bottom: 10px;
}
/* New Timeline style */
.vertical-container {
  /* this class is used to give a max-width to the element it is applied to, and center it horizontally when it reaches that max-width */
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
}
.vertical-container::after {
  /* clearfix */
  content: '';
  display: table;
  clear: both;
}
#vertical-timeline {
  position: relative;
  padding: 0;
  margin-top: 2em;
  margin-bottom: 2em;
}
#vertical-timeline::before {
  content: '';
  position: absolute;
  top: 0;
  left: 18px;
  height: 100%;
  width: 4px;
  background: #f1f1f1;
}
.vertical-timeline-content .btn {
  float: right;
}
#vertical-timeline.light-timeline:before {
  background: #e7eaec;
}
.dark-timeline .vertical-timeline-content:before {
  border-color: transparent #f5f5f5 transparent transparent ;
}
.dark-timeline.center-orientation .vertical-timeline-content:before {
  border-color: transparent  transparent transparent #f5f5f5;
}
.dark-timeline .vertical-timeline-block:nth-child(2n) .vertical-timeline-content:before,
.dark-timeline.center-orientation .vertical-timeline-block:nth-child(2n) .vertical-timeline-content:before {
  border-color: transparent #f5f5f5 transparent transparent;
}
.dark-timeline .vertical-timeline-content,
.dark-timeline.center-orientation .vertical-timeline-content {
  background: #f5f5f5;
}
@media only screen and (min-width: 1170px) {
  #vertical-timeline.center-orientation {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  #vertical-timeline.center-orientation:before {
    left: 50%;
    margin-left: -2px;
  }
}
@media only screen and (max-width: 1170px) {
  .center-orientation.dark-timeline .vertical-timeline-content:before {
    border-color: transparent #f5f5f5 transparent transparent;
  }
}
.vertical-timeline-block {
  position: relative;
  margin: 2em 0;
}
.vertical-timeline-block:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-block:first-child {
  margin-top: 0;
}
.vertical-timeline-block:last-child {
  margin-bottom: 0;
}
@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-block {
    margin: 4em 0;
  }
  .center-orientation .vertical-timeline-block:first-child {
    margin-top: 0;
  }
  .center-orientation .vertical-timeline-block:last-child {
    margin-bottom: 0;
  }
}
.vertical-timeline-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 16px;
  border: 3px solid #f1f1f1;
  text-align: center;
}
.vertical-timeline-icon i {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-left: -12px;
  margin-top: -9px;
}
@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-icon {
    width: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    -webkit-transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    font-size: 19px;
  }
  .center-orientation .vertical-timeline-icon i {
    margin-left: -12px;
    margin-top: -10px;
  }
  .center-orientation .cssanimations .vertical-timeline-icon.is-hidden {
    visibility: hidden;
  }
}
.vertical-timeline-content {
  position: relative;
  margin-left: 90px;
  background: white;
  border-radius: 0.25em;
  padding: 1em;
  height: 125px;
}
.vertical-timeline-content:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-content h2 {
  font-weight: 400;
  margin-top: 4px;
}
.vertical-timeline-content p {
  margin: 1em 0;
  line-height: 1.6;
}
.vertical-timeline-content .vertical-date {
  float: left;
  font-weight: 500;
}
.vertical-date small {
  color: #1ab394;
  font-weight: 400;
}
.vertical-timeline-content::before {
  content: '';
  position: absolute;
  top: 16px;
  right: 100%;
  height: 0;
  width: 0;
  border: 18px solid transparent;
  border-right: 7px solid white;
}
@media only screen and (min-width: 768px) {
  .vertical-timeline-content h2 {
    font-size: 18px;
  }
  .vertical-timeline-content p {
    font-size: 13px;
  }
}

@media only screen and (min-width: 1170px) {
  .center-orientation .vertical-timeline-content {
    margin-left: 0;
    padding: 1.6em;
    width: 35%;
    border: 1px solid #e7eaec
  }
  .center-orientation .vertical-timeline-content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left: 20px solid gray;
  }
  .center-orientation .vertical-timeline-content .btn {
    float: left;
  }
  .center-orientation .vertical-timeline-content .vertical-date {
    position: absolute;
    width: 100%;
    left: 122%;
    top: 2px;
    font-size: 14px;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content {
    float: right;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right: 20px solid gray;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .btn {
    float: right;
  }
  .center-orientation .vertical-timeline-block:nth-child(even) .vertical-timeline-content .vertical-date {
    left: auto;
    right: 122%;
    text-align: right;
  }
  .center-orientation .cssanimations .vertical-timeline-content.is-hidden {
    visibility: hidden;
    
  }

  /**
* Custom timeline
*/


#vertical-timeline{
	margin-left: .8%;
}

.timeline-circle-orange{
	background-color:var(--primary);
    color: #FFFFFF;
    width: 54px;
    height: 54px;
}

.custom-timeline-widget-top h2{
    font-size: 14px;
    font-weight: 400;
}

.custom-timeline-widget-top p{
    font-size: 12px;
    font-weight: 400;
}

.custom-timeline-widget h4{
    font-size: 14px;
    font-weight: 400;
     margin: 0 0 0px !important;
     margin-top: 0px !important;
     margin-bottom: 0px !important; 

}

.custom-timeline-widget p{
    font-size: 12px;
    font-weight: 400;
}

.custom-timeline-widget-top{
    background-color: #FFFFFF;
    color: #000;
    padding-left: 17px;
    padding-right: 17px;
    padding-bottom: 15px;
    padding-top: 5px;
    height: 125px;
    max-height: 150px;
    margin-bottom: 25px;
    margin-top: 225px;
    border: 1px solid #e7eaec;
    border-radius: 5%;
}

.custom-timeline-widget-top::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -8.666%;
    height: 0;
    width: 0;
    border: 20px solid transparent;
    border-bottom: 18px solid #676a6c;
}



.custom-timeline-widget{
    background-color: #FFFFFF;
    color: #000;
    padding-left: 17px;
    padding-right: 17px;
    padding-bottom: 15px;
    padding-top: 5px;
    height: 125px;
    max-height: 150px;
    margin-bottom: 25px;
    border: 1px solid #e7eaec;
    border-radius: 5%;
}

.custom-timeline-widget::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -8.666%;
    height: 0;
    width: 0;
    border: 20px solid transparent;
    border-top: 18px solid #676a6c;
}

#custom-timeline {
  position: relative;
  padding: 0;
  margin-top: 2em;
  margin-bottom: 2em;
}

#custom-timeline::before {
  content: '';
  position: absolute;
  top: 46%;
  left: 10%;
  right: 12%;
  height: 3px;
  width: 70%;
  background: #e7eaec;
}

.custom-timeline-icon-top{
  position: absolute;
  left: 50%;
  margin-left: -10.666%;
  top: 119%;  
  width: 54px;
  height: 54px;
  border-radius: 50%;
  font-size: 16px;
  border: 3px solid #f1f1f1;
  text-align: center;
}

.custom-timeline-icon-top i {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-left: -12px;
  margin-top: -9px;
}

.custom-timeline-icon-bottom{
  position: absolute;
  left: 50%;
  margin-left: -11.2%;
  bottom: 120%;  
  width: 54px;
  height: 54px;
  border-radius: 50%;
  font-size: 16px;
  border: 3px solid #f1f1f1;
  text-align: center;
}

.custom-timeline-icon-bottom i {
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
  left: 50%;
  top: 50%;
  margin-left: -12px;
  margin-top: -9px;
}

/** 
*   MOBILE TABLET CUSTOM TIMELINE 
**/
@media (max-width: 767px) {
    .custom-timeline-widget-top{
        background-color: #FFFFFF;
        color: #000;
        padding-left: 17px;
        padding-right: 17px;
        padding-bottom: 15px;
        padding-top: 5px;
        height: 105px;
        width: 55%;
        max-height: 200px;
        margin-bottom: 50px;
        margin-top: 0px;
        border: 1px solid #e7eaec;
        border-radius: 5%;
        left: 30%;
    }

    .custom-timeline-widget-top::before {
        content: '';
        position: absolute;
        bottom: 50%;
        left: 0;
        right: 0;
        margin-left: -38px;
        top: 32px;
        height: 0;
        width: 0;
        border: 20px solid transparent;
        border-right: 18px solid #676a6c;
    }

    .custom-timeline-widget{
        background-color: #FFFFFF;
        color: #000;
        padding-left: 17px;
        padding-right: 17px;
        padding-bottom: 15px;
        padding-top: 5px;
        height: 105px;
        width: 55%;
        max-height: 200px;
        margin-bottom: 50px;
        border: 1px solid #e7eaec;
        border-radius: 5%;
        left: 30%;
    }

    .custom-timeline-widget::before {
        content: '';
        position: absolute;
        bottom: 50%;
        left: 0;
        right: 0;
        margin-left: -38px;
        top: 32px;
        height: 0;
        width: 0;
        border: 20px solid transparent;
        border-right: 18px solid #676a6c;
    }

    #custom-timeline {
      position: relative;
      padding: 0;
      margin-top: 2em;
      margin-bottom: 2em;
    }

    #custom-timeline::before {
      content: '';
      position: absolute;
      top: 60px;
      bottom: 1%;
      left: 15px;
      right: 12%;
      height: 315px;
      width: 3px;
      background: #e7eaec;
    }

    .custom-timeline-icon-top{
      position: absolute;
      left: -44%;
      margin-left: -15%;
      top: 30%;  
      width: 54px;
      height: 54px;
      border-radius: 50%;
      font-size: 16px;
      border: 3px solid #f1f1f1;
      text-align: center;
    }

    .custom-timeline-icon-top i {
      display: block;
      width: 24px;
      height: 24px;
      position: relative;
      left: 50%;
      top: 50%;
      margin-left: -12px;
      margin-top: -9px;
    }

    .custom-timeline-icon-bottom{
      position: absolute;
      left: -44%;
      margin-left: -15%;
      bottom: 22%;  
      width: 54px;
      height: 54px;
      border-radius: 50%;
      font-size: 16px;
      border: 3px solid #f1f1f1;
      text-align: center;
    }

    .custom-timeline-icon-bottom i {
      display: block;
      width: 24px;
      height: 24px;
      position: relative;
      left: 50%;
      top: 50%;
      margin-left: -12px;
      margin-top: -9px;
    }

}

.timeline .timeline-item .timeline-badge.orange{
    background: #FF7007;
}
body.rtls .center-orientation .vertical-timeline-icon i {
  margin-left: 0;
  margin-right: -12px;
}
body.rtls .vertical-timeline-icon i {
  right: 50%;
  left: auto;
  margin-left: auto;
  margin-right: -12px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/seguridad/perfilUsuario/PerfilUsuario.vue